<template>
    <div class="container" v-show="show">
        <div class="row">
            <div class="col-xl-12">
                <legend class="mincho">
                    <i class="fas fa-heart" v-if="book.favorite" title="お気に入り"></i>
                    <i class="fas fa-book-open" v-if="book.hondana_id" title="展示"></i>
                    <h2 class="inherit title" v-html="$filters.ruby(book.title)"></h2>
                    <span class="gothic badge" :class="['badge-' + book.rating.color]" v-if="book.rating">{{book.rating.rating_name}}</span>
                    <span class="gothic badge" v-if="book.finish_status" :class="{
                        'badge-primary': book.finish_status === '連載中',
                        'badge-dark': book.finish_status === '完結',
                        'badge-success': book.finish_status === '完結予定',
                    }">{{book.finish_status}}</span>
                    <h3 class="inherit d-block subtitle" v-html="$filters.ruby(book.subtitle)"></h3>
                </legend>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-4 book-status px-0">
                <div class="row noline mb-3" v-if="book.cover_url">
                    <img :src="book.cover_url + '?' + book.cover_hash" class="img-fluid img-thumbnail mx-auto d-block cover" />
                </div>
                <div class="row noline mb-2 position-relative" v-else>
                    <img :src="cover()" class="img-fluid img-thumbnail mx-auto d-block cover" />                    <div class="book-text">
                    <div class="cover-text vertical">
                        <h3 class="novel-title mincho" v-html="$filters.ruby(book.title)"></h3>
                        <p v-if="book.subtitle" v-html="$filters.ruby(book.subtitle)"></p>
                    </div>
                </div>

                </div>
                <div class="sticky book-property">
                    <div class="row">
                        <div class="col-12 small">
                            <span class="author-name" v-if="book && book.author">
                                <ruby>
                                    {{book.author.name}}
                                    <rt v-if="book.author.kana">{{book.author.kana}}</rt>
                                </ruby>
                            </span>
                            <span v-if="book.is_long" class="badge badge-primary">長編</span>
                            <span v-else class="badge badge-warning">短編</span>
                            <div class="characters" v-if="book && book.property">
                                {{ $filters.numberFormat(book.episodes) }} 話 / {{$filters.numberFormat(book.property.published_chars )}} 文字
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="showSeries">
                        <div class="col-12 small">
                            <router-link :to="`/author/series/${book.series_id}`">
                                {{book.series.series_name}}
                                <i class="fas fa-layer-group"></i>
                            </router-link>
                        </div>
                    </div>
                    <div class="row" v-if="book.tags && book.tags.length">
                        <div class="col-12">
                            <ul class="tag-list mx-0 small">
                                <li v-for="t in book.tags" :key="t.id">
                                    <router-link :to="'/search?keywords=' + encodeURI(t.tag_name)" class="black">
                                        {{t.tag_name}}
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row" v-if="book.urls && book.urls.length">
                        <div class="col-12">
                            <novel-site v-for="u in book.urls" :url="u.url" :domain="u.domain" :key="u.id"></novel-site>
                        </div>
                    </div>
                    <div class="row" v-if="book.property">
                        <div class="col-12">
                            <div class="small">
                                <time :datetime="book.property.first_published_at" itemprop="datepublished">{{$filters.dateFormat(book.property.first_published_at)}}</time>
                                公開
                            </div>
                            <div class="small">
                                <time :datetime="book.property.last_published_at" itemprop="datemodified">{{$filters.dateFormat(book.property.last_published_at)}}</time>
                                更新
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="book.banner && book.banner.picture">
                        <div class="col-12">
                            <div class="small">リンク用バナー</div>
                            <img :src="book.banner.picture.url +'?'+ book.banner.picture.hash" alt="小説リンクバナー" class="img-thumbnail img-link">
                        </div>
                    </div>
                    <div class="row noline" v-if="book.property && book.property.is_finished && book.has_epub">
                        <div class="col-xl-12">
                            <a :href="`/author/book/epub?id=${this.book.id}`" class="btn btn-outline-warning btn-sm btn-block">
                                <i class="fas fa-book-open"></i>
                                電子書籍をダウンロード
                            </a>
                        </div>
                    </div>
                    <div class="row d-none d-lg-block mt-3" v-if="articles.length">
                        <div class="col">
                            <article-card
                                v-for="a in articles"
                                :key="'article-' + a.id"
                                :showPreface="true"
                                :bg="false"
                                :h100="false"
                                :article="a"></article-card>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="row pb-4 pt-1">
                    <div class="col-md-12">
                        <div class="btn-group btn-block book-control">
                            <router-link class="btn btn-primary btn-sm" :to="historyUrl" v-if="historyUrl">
                                <span v-if="book.history">続きから読む</span>
                                <span v-else>最初から読む</span>
                            </router-link>
                            <button type="button" class="btn btn-dark btn-sm"
                                :class="{'btn-clicked': book.favorite}"
                                v-if="$store?.state?.user && !isMyBook" @click="toggleFavorite()">
                                <span v-if="book.favorite">お気に入りから外す</span>
                                <span v-else>お気に入りに入れる</span>
                            </button>
                            <button type="button" class="btn btn-success btn-sm"
                                :class="{ 'btn-clicked': book.hondana_id }"
                                v-if="$store?.state?.user && !isMyBook" @click="showAddHondana()">
                                <span v-if="!book.hondana_id">展示棚に入れる</span>
                                <span v-else>展示棚から外す</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div v-html="$filters.url(book.description)" class="description b-light mincho"></div>
                <div class="row d-flex justify-content-center" v-if="outlines.length > 0">
                    <div class="slider">
                        <div class="slider-item" v-for="o in outlines" :key="o.id">
                            <router-link :to="`/author/page/${$route.params.book_id}/section/${o.section_id}`" class="text-reset no-hover">
                                <img :src="o.picture.thumb_url + '?hash=' + o.picture.hash" class="episode-bg" v-if="o.picture">
                                <div class="episode-number">
                                    エピソード{{o.section.episode_number}}
                                </div>
                                <div class="episode-title mincho">
                                    {{o.section.section_name}}
                                </div>
                                <div class="synopsis mincho" v-html="synopsis(o)"></div>
                                <div class="episode-chars">
                                    {{ $filters.numberFormat(o.section.characters) }} 文字
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="list-group list-group-no-border">
                    <router-link v-for="s in sections.data"
                        :to="`/author/page/${$route.params.book_id}/section/${s.id}`"
                        :key="s.id"
                        :class="{disabled: s.is_chapter}"
                        class="list-group-item list-group-item-action flex-column align-items-start book-content">
                        <div class="row no-gutter pr-3">
                            <div class="col-lg-11">
                                <h4 class="inherit p-0 mt-1" :class="{'line-right': !s.is_chapter, 'text-primary': s.id == book.history}">
                                    <i class="fas fa-bookmark bookmark" v-if="s.id == book.history"></i>
                                    <span class="inherit m-0" v-if="s.section_name" v-html="$filters.ruby(s.section_name)"></span>
                                    <span class="inherit m-0" v-else>（無題）</span>
                                </h4>
                            </div>
                            <div class="col-lg-1 chars mt-1" v-if="!s.is_chapter"><small>{{$filters.numberFormat(s.characters )}} 文字</small></div>
                        </div>
                    </router-link>
                    <div class="list-group-item" ref="infinity" v-if="sections && sections.last_page > page">
                        <a href="#" class="btn-link text-reset" @click.prevent="goto(page + 1)">
                            更に読み込む...
                        </a>
                    </div>
                </div>
                <div class="row d-block d-lg-none mt-3" v-if="articles.length">
                    <div class="col">
                        <article-card
                            v-for="a in articles"
                            :key="'article-' + a.id"
                            :bg="false"
                            :h100="false"
                            :article="a"></article-card>
                    </div>
                </div>
            </div>
        </div>
        <add-hondana
            :book="book"
            @saved="load()"></add-hondana>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="false"></loading>
    </div>
</template>

<style scoped lang="scss">
.title {
    font-size: 2rem;
}
.subtitle {
    font-size: 1.1rem;
}
.bookmark {
    padding-inline-end: .5rem;
}
.author-name {
    font-size: 1rem;
    display: inline-block;
    margin-right: 1rem;
}
.characters {
    display: inline-block;
    margin-left: 1rem;
}
.list-group-no-border {
    .list-group-item {
        border-width: 0;
    }
}
.btn-clicked {
    opacity: .6;
}
.line-right {
    display: flex;
    align-items: center;
    &:after {
        content: "";
        flex-grow: 1;
        height: 1px;
        display: block;
        margin-left: .4rem;
        background: #ddd;
    }
}
.book-property {
    overflow: scroll;
    max-height: calc(100dvh - 43px);
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar{
        display:none;
    }
    .row {
        margin: 0;
    }
}
.cover {
    object-fit: cover;
    height: 535px;
    width: 380px;
}
.img-link {
    width: calc(200px + 0.5rem + 2px);
    height: calc(40px + 0.5rem + 2px);
}
.book-status {
    overflow: hidden;
    .row {
        border-bottom: 1px dashed #cacaca;
        [class^="col-"] {
            padding: .7em;
        }
        &.noline {
            border: 0;
        }
    }
    margin-bottom: 2em;
    .book-text {
        position: absolute;
        top: 0;
        padding: 2.3rem;
        height: 535px;
        min-width: 375px;
        overflow: hidden;
        text-align: center;
        color: snow;
        width: 100%;
        .cover-text {
            display: inline-block;
            text-align: left;
            h3 {
                font-size: 1.6rem;
            }
            p {
                font-size: 1rem;
            }
        }
    }
}
.description {
    padding: 1.5rem;
    font-size: .8rem;
    margin-bottom: 1rem;
}
.section-group {
    margin: 1.5em 0 1em;
}
.caption {
    font-size: 1.1rem;
    padding: .5em 1.1em;
    border-left: 3px solid #ddd;
}
.chars {
    text-align: right;
    white-space: nowrap;
    overflow: visible;
    padding: 0;
}
.badge {
    font-size: 14px;
}
.no-hover {
    &:hover {
        text-decoration: none;
    }
}
.slider {
    display: flex;
    overflow: scroll;
    margin: 0 15px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    margin: -1rem 0 .5rem;
    justify-content: center;
    flex-wrap: wrap;
    &::-webkit-scrollbar {
        display:none;
    }
    .slider-item {
        width: 210px;
        padding: 10px 15px 35px;
        border-radius: .5rem;
        background-color: #aaa3;
        margin: 1rem;
        position: relative;
        overflow: hidden;
        .episode-bg {
            pointer-events: none;
            position: absolute;
            top: 0;
            left: 0;
            width: 210px;
            height: 333px;
            opacity: 0.15;
            object-fit: cover;
        }
        .episode-number {
            font-size: 0.7rem;
            opacity: 0.8;
        }
        .episode-title {
            font-size: 1rem;
            margin: .5rem 0;
        }
        .synopsis {
            letter-spacing: 0.05rem;
            font-size: 0.7rem;
            opacity: 0.8;
        }
        .episode-chars {
            font-size: 0.7rem;
            text-align: right;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            padding: 0 1rem 0.5rem;
            opacity: 0.8;
        }
    }
}
@media (max-width: 991px) {
    .chars {
        margin-top: -1rem;
        padding-right: 15px;
    }
    .publish {
        text-align: right;
    }
}
@media (max-width: 768px) {
    .book-control {
        .btn {
            padding: 0.2rem 0.5rem;
            font-size: 0.7rem;
        }
    }
}
</style>

<script>
import novelSite from "components/Site";
import articleCard from "./articleCard";
import addHondana from "./addHondana";
export default {
    components: {
        novelSite,
        articleCard,
        addHondana,
    },
    data() {
        return {
            sections: {},
            book: {},
            articles: [],
            outlines: [],
            show: false,
            page: 1,
            isLoading: false,
            isInit: false,
        }
    },
    head: {
        title() {
            return {
                inner: this.book.title || "",
                separator: "|",
                complement: this.$store.state.bookshelf_name,
            }
        },
        meta() {
            return [
                { name: "keywords", content: this.book?.author?.keywords || "Web小説,オンライン小説,縦書き小説,小説投稿,小説置き場", id: "meta-keywords" },
                { name: "description", content: this.description, id: "meta-description" }
            ]
        },
        link() {
            return [
                { rel: "canonical", href: location.origin + location.pathname, id: "canonical" },
            ]
        }
    },
    methods: {
        goto(page = 1) {
            if (this.isLoading) return;
            this.isLoading = true;
            this.page = page;
            setTimeout(() => {this.load()});
        },
        load() {
            // 目次読み込み
            if (!this.book.id) {
                this.show = false;
            }
            axios.get("/author/book/sections/get", {
                params: {
                    book_id: this.$route.params.book_id,
                    page: this.page
                }
            }).then(res => {
                if (this.page == 1) {
                    this.sections = res.data;
                } else {
                    this.sections.data = this.sections.data.concat(res.data.data);
                }
                if (this.page < this.sections.last_page) {
                    // インフィニティ設定
                    setTimeout(() => {
                        if (this.$refs.infinity) {
                            const options = {
                                root: null,
                                rootMargin: '0px 0px',
                                threshold: 1,
                            };
                            const observer = new IntersectionObserver((entries, observer) => {
                                if (!this.isInit) {
                                    this.isInit = true;
                                    return;
                                }
                                this.isInit = false;
                                observer.unobserve(this.$refs.infinity);
                                this.goto(this.page + 1);
                            }, options);
                            observer.observe(this.$refs.infinity);
                        }
                    });
                }
                this.isLoading = false;
                this.loadBook();
            }).catch(err => {
                if (err?.response?.status == 404) {
                    alert.err("指定の小説は存在しないか、公開が停止されています。");
                    this.$router.push("/");
                } else if (err?.response?.status == 403) {
                    alert.err(err);
                    this.$router.push("/");
                } else {
                    alert.err(err);
                }
            }).finally(() => {
                this.isLoading = false;
            });
        },
        loadBook() {
            // 本読み込み
            axios.get("/author/book/get", {params: {book_id: this.$route.params.book_id}}).then(res => {
                this.book = res.data;
                if (! this.$store.state.user) {
                    const history = this.$cookie.get('history');
                    if (history) {
                        for (const [k, v] of Object.entries(history)) {
                            if (_.find(this.sections.data, {"id": v.section_id})) {
                                this.book.history = v.section_id;
                                break;
                            }
                        }
                    }
                }
                this.show = true;
                setTimeout(() => {
                    this.makeHead();
                });
            }).catch(err => {
                alert.err(err);
                if (err?.response?.status == 403) {
                    // 不正なアクセスのときはトップページに戻す
                    this.$router.push("/");
                }
            });
        },
        loadArticles() {
            axios.get("/author/articles/book", {params: {id: this.$route.params.book_id}}).then(res => {
                this.articles = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        loadOutlines() {
            axios.get("/author/outlines/get", {params: {id: this.$route.params.book_id}}).then(res => {
                this.outlines = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        toggleFavorite() {
            axios.post("/author/book/favorite/toggle", {id: this.book.id}).then(res => {
                this.loadBook();
            }).catch(err => {
                alert.err(err.response);
            });
        },
        cover() {
            if (!this.$store.getters.novelCovers.length) {
                return "/img/404.jpg";
            }
            const index = Math.floor(Math.random() * this.$store.getters.novelCovers.length);
            return this.$store.getters.novelCovers[index];
        },
        makeHead() {
            this.useHead({
                title: this.book?.title + " | " + this.$store.state.bookshelf_name,
                link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ],
                meta: [
                    { name: "keywords", content: this.book?.author?.keywords || "Web小説,オンライン小説,縦書き小説,小説投稿,小説置き場", id: "meta-keywords" },
                    { name: "description", content: this.description, id: "meta-description" }
                ]
            });
        },
        synopsis(o) {
            return this.$filters.ruby(this.$filters.truncate(o.synopsis || o.section.body.replace(/<i\d+\|\d+>/ug, '').trim(), 140));
        },
        showAddHondana() {
            if (this.book.hondana_id) {
                // 本棚から外す
                axios.post("/mypage/genre/books/add", {
                    genre_id: this.book.hondana_id,
                    book_id: this.book.id
                }).then(res => {
                    alert.msg(res.data);
                    this.load();
                }).catch(err => { alert.err(err.response); });
            } else {
                $("#add-hondana").modal("show");
            }
        }
    },
    computed: {
        // 履歴のURL（なければ１話目）
        historyUrl() {
            if (this.book.history) {
                return `/author/page/${this.book.id}/section/${this.book.history}`;
            }
            const first = _.minBy(this.sections, (o) => { return (!o.is_chapter) ? o.order_number : null;});
            if (first) {
                return `/author/page/${this.book.id}/section/${first.id}`;
            }
            return null;
        },
        description() {
            return this.book?.description?.replace(/[\r\n]/ug, "").substr(0, 120) || "小説を書くこと、読むことにフォーカスした小説投稿サイトです。作家さんが独自のサブドメインで、ご自身の小説を公開できます。";
        },
        showSeries() {
            if (this.book?.author?.subdomain == this.$store.state?.subdomain && this.book?.series_id) {
                return true;
            }
            return false;
        },
        isMyBook() {
            if (this.book?.user_id == this.$store?.state?.user?.id) {
                return true;
            }
            return false;
        },
    },
    mounted() {
        this.load();
        this.loadArticles();
        this.loadOutlines();
    }
}
</script>